import { Outlet } from 'react-router-dom';

const UserMappedRoutes = () => {
    return <Outlet />;
}

export default UserMappedRoutes
